// eslint-disable-next-line import/prefer-default-export
export const DEVICE = {
  WEB: 'bow-web',
  MOBILE: 'mobile-app',
  MOBILE_LEGACY: 'mobile',
  MOBILE_BROWSER: 'mobile-web',
};
